<div class="partial-refund-dialog p-3">
  <div class="flex justify-end">
    <button type="button" (click)="cancel()" class="!rounded-full" aria-label="Close dialog">
      <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
        <circle opacity="0.05" cx="20" cy="20" r="20" fill="#E71D36" />
        <path opacity="0.8"
          d="M20.9161 19.9999L24.8099 23.8939C25.0634 24.1472 25.0634 24.5567 24.8099 24.81C24.5567 25.0633 24.1471 25.0633 23.8939 24.81L19.9999 20.916L16.1061 24.81C15.8527 25.0633 15.4433 25.0633 15.1901 24.81C14.9366 24.5567 14.9366 24.1472 15.1901 23.8939L19.0839 19.9999L15.1901 16.1059C14.9366 15.8526 14.9366 15.4431 15.1901 15.1898C15.3163 15.0635 15.4822 15 15.6481 15C15.8139 15 15.9798 15.0635 16.1061 15.1898L19.9999 19.0838L23.8939 15.1898C24.0202 15.0635 24.1861 15 24.3519 15C24.5178 15 24.6836 15.0635 24.8099 15.1898C25.0634 15.4431 25.0634 15.8526 24.8099 16.1059L20.9161 19.9999Z"
          fill="#E71D36" />
      </svg>
    </button>
  </div>

  <h2 class="text-[#17191C] text-lg font-semibold mb-2">Partial refund</h2>
  <p class="text-sm text-gray-600 mb-4 leading-relaxed">
    Enter the amount you want to refund to the customer. This cannot exceed the
    original transaction amount.
  </p>

  <div class="rounded-xl bg-gray-50 p-4 mb-5">
    <div class="space-y-4 text-sm">
      @if (data.customerEmail) {
      <div class="flex gap-3 justify-between items-center border-b border-[#ECECEC] pb-3">
        <span class="text-gray-500">Customer</span>
        <span class="text-[#434C53] text-end">{{ data.customerEmail }}</span>
      </div>
      }
      <div class="flex gap-3 justify-between items-center border-b border-[#ECECEC] pb-3">
        <span class="text-gray-500">Original amount</span>
        <span class="text-[#434C53] font-medium tabular-nums">{{
          data.originalAmountDisplay
          }}</span>
      </div>
      @if (data.transactionRef) {
      <div class="flex gap-3 justify-between items-center pb-1">
        <span class="text-gray-500">Reference</span>
        <span class="text-[#434C53] text-end break-all">{{
          data.transactionRef
          }}</span>
      </div>
      }
    </div>
  </div>

  <div class="mb-4">
    <!-- Prefix row: [appDecimal] + [appAmount] are only wired in this layout (not default app-input). -->
    <app-input [autofocus]="true" [showPrefix]="true" [control]="refundAmount" [decimal]="true" [amount]="true"
      type="text" id="refund-amount" label="Refund amount" [secondaryLabel]="'(NGN)'" placeholder="0.00"
      errorMessage="Enter a valid amount up to the original transaction value.">
      <span prefix class="text-sm font-medium text-grey-500 select-none">₦</span>
    </app-input>
    @if (resolvedMaxMajor != null) {
    <p class="mt-1 text-xs text-gray-500">
      Maximum:
      {{ resolvedMaxMajor | number: '1.2-2' }}
      NGN
    </p>
    }
    @if (
    refundAmount.hasError('exceedsMax') &&
    (refundAmount.touched || refundAmount.dirty)
    ) {
    <p class="text-red-500 text-xs mt-1">
      Refund amount cannot be greater than the maximum allowed ({{
      resolvedMaxMajor != null
      ? (resolvedMaxMajor | number: '1.2-2')
      : data.maxRefundAmount
      }}
      NGN).
    </p>
    }
    @if (
    refundAmount.hasError('belowMin') &&
    (refundAmount.touched || refundAmount.dirty)
    ) {
    <p class="text-red-500 text-xs mt-1">
      Enter at least 0.01 NGN.
    </p>
    }
    @if (
    refundAmount.hasError('invalidAmount') &&
    (refundAmount.touched || refundAmount.dirty)
    ) {
    <p class="text-red-500 text-xs mt-1">Enter a valid amount.</p>
    }
  </div>

  <div class="mb-6">
    <label class="block text-sm font-medium text-gray-700 mb-2" for="refund-reason">
      Reason <span class="text-gray-400 font-normal">(optional)</span>
    </label>
    <textarea id="refund-reason" rows="4" [formControl]="reason" placeholder="Add a short note for this partial refund"
      class="w-full resize-none rounded-lg border border-gray-200 p-3 text-sm text-gray-700 placeholder-gray-400 focus:border-blue-500 focus:outline-none focus:ring-2 focus:ring-blue-100"></textarea>
  </div>

  <div class="flex flex-col gap-3 sm:flex-row sm:justify-end">
    <app-button type="button"
      [inputClass]="'!border !border-primary !bg-white !text-primary sm:!w-auto !order-2 sm:!order-1'"
      (buttonClick)="cancel()">
      Cancel
    </app-button>
    <app-button type="button" [inputClass]="'sm:!w-auto !order-1 sm:!order-2'" (buttonClick)="onSubmit()">
      Confirm refund
    </app-button>
  </div>
</div>